export default function loadCookielaw($button: HTMLButtonElement) {
	$button.addEventListener('click', () => {
		if (window.Cookielaw) {
			window.Cookielaw.accept();
		}
	});
}
